import React, { useState } from 'react';
import { Box, TextField, Button, Typography, IconButton, InputAdornment, FormControl, Backdrop } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { forgotUserPassword } from '../../../apiCalls/urls/urlFunction';
import { actionNotifier } from '../../../components/tostify';
import CircularProgress from '@mui/material/CircularProgress';
import { useNavigate } from 'react-router-dom';
import BasicBtn from "../../../components/button/BasicBtn";

function MobileNewPassword({ forgotToken }) {
    const [showPassword, setShowPassword] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleClickShowPassword = () => setShowPassword(!showPassword);

    const handleMouseDownPassword = (event) => event.preventDefault();

    return (
        <Box
            sx={{
                mt: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Typography variant="h5" fontWeight={400} sx={{ mb: 3 }}>
                Forget Password
            </Typography>

            <FormControl
                component={'form'}
                method='POST'
                onSubmit={handleSubmit}
                fullWidth
            >
                {/* New Password Input */}
                <TextField
                    type={showPassword ? 'text' : 'password'}
                    variant="outlined"
                    label="New Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    fullWidth
                    error={!!errors.newPassword}
                    helperText={errors.newPassword}
                    sx={{
                        marginBottom: 2,
                        backgroundColor: 'white',
                        borderRadius: '10px',
                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                {/* Confirm Password Input */}
                <TextField
                    type={showPassword ? 'text' : 'password'}
                    variant="outlined"
                    label="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    fullWidth
                    error={!!errors.confirmPassword}
                    helperText={errors.confirmPassword}
                    sx={{
                        marginBottom: 3,
                        backgroundColor: 'white',
                        borderRadius: '10px',
                    }}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />

                <BasicBtn
                    type="submit"
                    name="Update Password"
                    color="secondary"
                    smColor="primary"
                    loading={loading}
                    disabled={loading}
                    sx={{ mt: 3 }}
                />
            </FormControl>

            <Backdrop
                sx={{ color: '#fff', zIndex: 999 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    );

    function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);

        // Validate inputs
        let validationErrors = {};

        if (newPassword.length < 1) {
            validationErrors.newPassword = 'New Password is Required field.';
        } else {
            if (newPassword.length < 6 || newPassword.length > 15) {
                validationErrors.newPassword = 'Password must be between 6 and 15 characters.';
            }
        }

        if (confirmPassword.length < 1) {
            validationErrors.confirmPassword = 'Confirm Password is Required field.';
        } else {
            if (confirmPassword.length < 6 || confirmPassword.length > 15) {
                validationErrors.confirmPassword = 'Confirm Password must be between 6 and 15 characters.';
            } else {
                if (newPassword !== confirmPassword) {
                    validationErrors.confirmPassword = 'Passwords do not match.';
                }
            }
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }

        // Clear errors if validation passed
        setErrors({});

        const payload = {
            password: newPassword,
            confirmPassword: confirmPassword,
            forgotToken: forgotToken
        };

        updateUserPassword(payload);
    }

    async function updateUserPassword(payload) {
        if (!loading) setLoading(true)
        const res = await forgotUserPassword(payload);

        try {

            if (res.status) {
                // Show success message or redirect
                actionNotifier.success('Password update successfully!', { position: "top-left", autoClose: 1000 });
                setNewPassword('');
                setConfirmPassword('');
                navigate('/login', { replace: true });
                setLoading(false);
            } else {
                // Show error message
                actionNotifier.error('Something went wrong. Please try again later.', { position: "top-left", autoClose: 1000 });
                setNewPassword('');
                setConfirmPassword('');
                setLoading(false);
            }
        } catch (error) {
            actionNotifier.error('Something went wrong. Please try again later.', { position: "top-left", autoClose: 1000 });
            setNewPassword('');
            setConfirmPassword('');
            setLoading(false);
        }
    }
}

export default MobileNewPassword;